export default [
	//中转空白路由
	{
		path: '/white',
		name: '空白',
		component: () => import(/* webpackChunkName: "whiteRouter" */ '@/views/white'),
	},
	//实名认证
	{
		path: '/certification',
		name: 'certification',
		title: '实名认证',
		component: () => import(/* webpackChunkName: "certification" */ '@/views/certification'),
	},
	// 精剪
	{
		path: '/finecut/:id/:fid/:pid',
		name: 'finecut',
		title: '视频精剪',
		component: () => import(/* webpackChunkName: "finecut" */ '@/views/finecut'),
	},
	// 绑定快手后通知原页面
	{
		path: '/ks/notice',
		name: 'ksNotice',
		title: 'notice',
		component: () => import(/* webpackChunkName: "ksNotice" */ '@/views/notice'),
	},
	// 选择企业内容
	{
		path: '/companyChoice',
		name: 'companyChoice',
		component: () => import('@/views/companyChoice'),
		hidden: true,
	},
	{
		path: '/login',
		name: 'login',
		component: () => import(/* webpackChunkName: "login" */ '@/views/login'),
		meta: {
			title: 'login',
		},
	},
	{
		path: '/resetPass',
		name: 'resetPass',
		component: () => import(/* webpackChunkName: "resetPass" */ '@/views/login/resetPass'),
		meta: {
			title: 'resetPass',
		},
	},
	// 登录失效提示
	{
		path: '/relogin',
		name: 'relogin',
		component: () => import(/* webpackChunkName: "reLogin" */ '@/views/relogin'),
		meta: {
			title: 'relogin',
		},
	},
	{
		path: '*',
		name: 'notfound',
		component: () => import(/* webpackChunkName: "notFound" */ '@/views/notfound'),
		meta: {
			title: '404',
		},
	},
];
